import { money, longDate } from "./format";

// Recorded deed (sale/transfer) and mortgage history, mirroring the public-record
// tables on the ez Home Search user-home page. Each table renders nothing when
// its data is empty.
function RecordTable({ title, columns, rows }) {
  if (!rows || rows.length === 0) return null;
  return (
    <section className="ssc-report-section">
      <h3>{title}</h3>
      <div className="ssc-report-table-wrap">
        <table className="ssc-report-table">
          <thead>
            <tr>{columns.map((c) => <th key={c.key}>{c.label}</th>)}</tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i}>
                {columns.map((c) => {
                  const out = c.render ? c.render(r[c.key], r) : r[c.key];
                  return <td key={c.key}>{out || out === 0 ? out : "—"}</td>;
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

const DEED_COLUMNS = [
  { key: "date", label: "Date", render: (v) => longDate(v) },
  { key: "buyer", label: "Buyer" },
  { key: "seller", label: "Seller" },
  { key: "price", label: "Price", render: (v) => (v ? money(v) : "—") },
  { key: "document_type", label: "Type" },
];

const MORTGAGE_COLUMNS = [
  { key: "date", label: "Date", render: (v) => longDate(v) },
  { key: "lender", label: "Lender" },
  { key: "loan_amount", label: "Loan amount", render: (v) => (v ? money(v) : "—") },
  { key: "interest_rate", label: "Rate", render: (v) => (v ? `${v}%` : "—") },
  { key: "loan_term_years", label: "Term", render: (v) => (v ? `${v} yrs` : "—") },
];

export default function PublicRecords({
  deeds,
  mortgages,
  deedsHeading = "Sale & deed history",
  mortgagesHeading = "Mortgage history",
}) {
  return (
    <>
      <RecordTable title={deedsHeading} columns={DEED_COLUMNS} rows={deeds} />
      <RecordTable title={mortgagesHeading} columns={MORTGAGE_COLUMNS} rows={mortgages} />
    </>
  );
}
